import { useEffect } from 'react'

import { useAuth } from 'commons/customHooks/useAuth'
import { URL_CONST } from 'constants/urls'
import { AuthLayout } from 'layouts/AuthLayout'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'store/store'

import LoginForm from './components/LoginForm'
import ValidateLogin from './components/ValidateLogin'

function Login() {
  const navigate = useNavigate()
  const { isAuthenticated } = useAuth()
  const { loginValidation } = useSelector((state) => state.structure)

  useEffect(() => {
    if (isAuthenticated()) navigate(URL_CONST.ROOT)
  }, [])

  return <AuthLayout>{loginValidation ? <ValidateLogin /> : <LoginForm />}</AuthLayout>
}

export default Login
